export {default} from './JumboThemeFooter';